import Barba from "barba.js";
import $ from 'jquery';
import smoothScroll from "smoothscroll";
import URLSearchParams from 'url-search-params'

const Directory = Barba.BaseView.extend({
  namespace: "directory",
  onEnter() {
    $('body').removeClass('ajax-listing-open');
  },
  onEnterCompleted() {
    const filterParams = {
      category: null,
      type: null,
      location: null
    }

    const setHeadline = () => {
      let cat = filterParams.category;
      let type = filterParams.type;
      let loc = filterParams.location;
      let typeHTML = $('.type-select option[value=' + type + ']').html();
      let locHTML = $('.location-select option[value=' + loc + ']').html();
      if($('.visible').length < 1 ){
        $('.widget__headline').html("Sorry, we don't have any listings for your request.")
      }
      else if(cat === null && type === null && loc === null){
        $('.widget__headline').html('Showing all listings')
      }
      else if(cat && type && loc){
        $('.widget__headline').html(`Showing ${typeHTML} ${cat}s in ${locHTML}`)
      }
      else if(cat && type){
        $('.widget__headline').html(`Showing ${typeHTML} ${cat}s`)
      }
      else if(cat && loc){
        $('.widget__headline').html(`Showing all ${cat}s in ${locHTML}`)
      }
      else if(type && loc){
        $('.widget__headline').html(`Showing ${typeHTML} listings in ${locHTML}`)
      }
      else if(cat){
        $('.widget__headline').html(`Showing all ${cat}s`)
      }
      else if(type){
        $('.widget__headline').html(`Showing ${typeHTML} listings`)
      }
      else if(loc){
        $('.widget__headline').html(`Showing listings in ${locHTML}`)
      }
    }

    const selected = (item) => {
      let cat = item.attr('data-category');
      let type = item.attr('data-type');
      let loc = item.attr('data-location');
      if(filterParams.category && filterParams.category !== cat){
        return false;
      }
      else if(filterParams.type && filterParams.type !== type){
        return false;
      }
      else if(filterParams.location && filterParams.location !== loc){
        return false;
      }
      else{
        return true;
      }
    }

    const filterListings = () => {
      $('.widget__item').each(function(){
        if(selected($(this))){
          $(this).addClass('visible')
        }
        else{
          $(this).removeClass('visible')
        }
      })
      $('.featured').addClass('featured--hidden');
      $('.results').removeClass('results--hidden');
      $('.widget').addClass('widget--active');
      $(".menu-desktop__quick-search").removeClass('visible');
      setHeadline()
      let element = document.querySelector('.widget__results');
      if(window.innerWidth < 768){
        smoothScroll(element);
      }
    }

    let url = new URL(window.location.href); // or construct from window.location
    let params = new URLSearchParams(url.search.slice(1));

    const filterOnLoad = () => {
      let category = params.get("cat");
      let type = params.get("type");
      let location = params.get("loc");


      if(category){
        filterParams.category = category;
        $('.category-select').val(category);
      }

      if(type){
        filterParams.type = type;
        $('.type-select').val(type);
      }

      if(location){
        filterParams.location = location;
        $('.location-select').val(location);
      }
      if(category || type || location){
        filterListings()
      }
      else{
        $('.featured').removeClass('featured--hidden');
      }

    }

    filterOnLoad()

    const disableType = () => {
      $('.type-select-container').addClass('disabled');
      $('.type-select').val("all").change();
    }

    const enableType = () => {
      $('.type-select-container').removeClass('disabled');
    }

    $('.category-select').change(function(){
      if($(this).val() == "all"){
        filterParams.category = null;
        enableType()
      }
      else if($(this).val() == "service"){
        filterParams.category = $(this).val();
        enableType();
      }
      else{
        filterParams.category = $(this).val();
        disableType();
      }
    });

    $('.type-select').change(function(){
      if($(this).val() == "all"){
        filterParams.type = null;
      }
      else{
        filterParams.type = $(this).val();
      }
    });

    $('.location-select').change(function(){
      if($(this).val() == "all"){
        filterParams.location = null;
      }
      else{
        filterParams.location = $(this).val();
      }
    });

    $('.widget__submit').click(function(){
      filterListings();
    })

    $('.widget__item, .results__item').click(function(event){
      event.preventDefault();
      ajaxListing($(this).attr('href'))
    })

    $('.listing__back-button').click(function(event){
      event.preventDefault();
      $('.ajax-listing').addClass('hidden')
      history.pushState('', '', '../directory');
      $('body').removeClass('ajax-listing-open');
      // $(".listing__content").html('');
    });

    if (window.history && window.history.pushState) {

        $(window).on('popstate', function() {
          if($('body').hasClass('ajax-listing-open')){
            $('body').removeClass('ajax-listing-open')
          }
        });

    }

    const ajaxListing = (url) => {
      $.ajax({
      url:url,
      success: function(response) {
        $(".listing__content").html($(response).find("#ajax-content"));
        $('.ajax-listing').removeClass('hidden')
        $('body').addClass('ajax-listing-open');
        $('.header-mobile, .header-desktop').removeClass('headroom--unpinned').addClass('headroom--pinned')
      }
      });
      history.pushState('', '', url);
      return false;
      }
  },
  onLeave() {
    this.destroy();
  },
  $el: null,
  _construct() {},
  destroy() {}
});

export default Directory;



// WEBPACK FOOTER //
// ./src/scripts/barba/views/directory.js